import { render, staticRenderFns } from "./managing-broker-approved.vue?vue&type=template&id=38615d21"
import script from "./managing-broker-approved.vue?vue&type=script&lang=js"
export * from "./managing-broker-approved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports